import request, { baseURL } from '@/utils/request/index'
import axios from 'axios'
import { UserModule } from '@/store/modules/user'
import {
  IUserInfo,
  LoginFormData,
  UserInfo,
} from '@/api/user/type'

// 查: 用户名是否可用
export const checkUsernameCanUse = (username: string) =>
  request.get<null>('/api/sys/user/checkUsername', {
    params: { username },
    baseURL
  })

// 查: 通过 Cookie 查询登录用户的信息
export const getUserInfo = () =>
  request<UserInfo>({
    baseURL,
    url: '/api/sys/user/info',
    method: 'get'
  })

export const login = (data: LoginFormData) =>
  request<string>({ // 登录成功返回 token
    baseURL,
    url: '/api/sys/login',
    method: 'post',
    data
  })

export const logout = () => {
  // 退出登录后端会清除用户登录信息，然后重定向到对应的地址
  const url = baseURL + request.getUri({
    url: '/api/sys/logout',
    params: {
      t: new Date().getTime()
    }
  })
  location.href = url
}

/**
 * 通过获取用户信息接口判断 token 是否有效
 * 如果有效则借助该接口对用户信息进行拉取
 * 如果失效则会通过在响应拦截器中抛异常
 * 1 次调用完成两件事情
 */
export function checkIsTokenValid (token: string) {
  return axios.get('/api/ucenter/info', {
    baseURL,
    headers: { Authentication: token }
  })
    .then((res) => {
      // TODO: 将该部分操作拆分到 login 钩子中
      UserModule.UpdateUserInfo({
        role: res.data.data.isAdmin ? 'admin' : 'user',
        ...res.data.data,
      })
    })
    .then(() => true)
    .catch(() => false) // 鉴权失败时 HTTP Status 是 401
}

// 该接口仅作为通过状态码判断是否已登录的接口使用
export const checkLoginApi = () => {
  return request.get(`/api/sys/auth`)
}

// 获取用户信息
export const getUserInfoApi = () =>
  request<IUserInfo>({
    baseURL,
    url: '/api/sys/user/getUserInfo',
    method: 'get'
  })

// 获取文件保存天数
export const getRetentionDays = () =>
  request<string>({
    baseURL,
    url: '/api/data/retentionDays',
    method: 'get'
  })

